// Pricing Model core
export function pricingModelCore() {
    const endpoint = '/saleschannels/PricingModels';
    const detailId = 'pricingModelCode';
  
    const getDetailId = (data = null) => {
      if (!data) {
        return;
      }
  
      if (Array.isArray(data)) {
        return data[0][detailId];
      }
  
      return data[detailId];
    };
  
    return {
      endpoint,
      detailId,
      getDetailId: getDetailId
    };
  }
  
  // Pricing Data Version  filter
  export function pricingModelFilter() {
    const parameter = 'PricingModelCode';
  
    // Get rows
    const getRows = (data) => {
      const rows = [];
  
      data.forEach((row, i) => {
        // Text/numeric values
        rows[i] = {
          value: row.pricingModelCode,
          label: row.pricingModelDescription
        };
      });
  
      return rows;
    };
  
    return {
      parameter,
      getRows: getRows
    };
  }
  